module.exports = __webpack_public_path__ + "img/lisa_valdez_picture.c894665e.png";